import type { MonoTypeOperatorFunction } from 'rxjs'
import { share } from 'rxjs/operators'

export const nonCancelableRequest =
  <T>(): MonoTypeOperatorFunction<T> =>
  source =>
    source.pipe(share({ resetOnRefCountZero: false, resetOnComplete: true, resetOnError: true }))
